import Backbone from 'backbone';
import Handlebars from 'handlebars';
import Spinner from './../../components/spinner.js';
import { EventHandler } from './../../../base/utils.js';

export default Backbone.View.extend({

  el: '.sizzle-wyzard-chat-component',

  events: {},

  initialize(options) {
    this.url = options.url || '';
    this.listenTo(window.App.Events, 'form:loaded', this.getTemplate);
    Spinner.appendTo(this.$el);
  },

  getTemplate() {
    $.ajax({
      url: this.url,
      success: (r) => {
        this.template = Handlebars.compile(r);
        this.render();
        EventHandler.send(EventHandler.lazyLoad.rebind);
      }
    });
  },

  render() {
    Spinner.remove(this.$el);
    this.$el.html(this.template());
  }
});
